module.exports = __webpack_public_path__ + "img/p1.b1e065e1.jpg";